// removed by extract-text-webpack-plugin
module.exports = {"main_right_content":"components-swbl-zytz-index-main_right_content--Vntx","table":"components-swbl-zytz-index-table-3tbiB"};


//////////////////
// WEBPACK FOOTER
// ./components/swbl/zytz/index.css
// module id = 2302
// module chunks = 0